// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__NtZMD","progress":"Loading_progress__SCr9S"};